import BasicFilters, {
  type BasicFiltersProps,
  type BasicFiltersValue,
  MultiSelectWide
} from '@features/todos/components/BasicFilters'
import type {
  CalculatedTaskStatus,
  LogCategory,
  LogCategoryItem
} from '@lmc/ts-common'
import { StatusBadge } from '@lmc/ui-kit'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { TempCalculatedTaskStatus } from '../hooks/useDailyTasks'

export type TaskFiltersValue = BasicFiltersValue & {
  status?: string[]
}

export type TaskFiltersProps = BasicFiltersProps<TaskFiltersValue> & {
  testId?: string
}

export const getName = (item: { name: { first: string; last: string } }) =>
  `${item.name.first} ${item.name.last}`

const TaskFilters = ({
  value,
  onChange,
  testId
}: TaskFiltersProps): JSX.Element => {
  const handleInputChange = (newValue: Partial<TaskFiltersValue>) => {
    const updatedValue: TaskFiltersValue = {
      ...value,
      ...newValue
    }

    onChange(updatedValue)
  }

  const {
    'log-category-items': categoryItems
  }: {
    'log-categories': LogCategory[] | undefined
    'log-category-items': LogCategoryItem[] | undefined
  } = useSelector((state: any) => state.data)

  let newCategoryItems = categoryItems?.filter((categoryItem) =>
    value?.categories?.includes(categoryItem.category)
  )

  if (!newCategoryItems?.length) {
    newCategoryItems = categoryItems
  }

  const statusOptions = Object.keys(TempCalculatedTaskStatus)
    .map((statusType) => ({
      label: statusType,
      value: statusType,
      image: (
        <StatusBadgeStyled
          key={statusType}
          status={statusType as CalculatedTaskStatus}
        />
      )
    }))
    .sort((a, b) => a.label.localeCompare(b.label))

  return (
    <BasicFilters value={value} onChange={handleInputChange} testId={testId}>
      <MultiSelectNarrow
        values={value.status}
        title="Status"
        options={statusOptions}
        hasClear
        hasSearch
        hasSelectAll
        onChange={(selectedStatus) =>
          handleInputChange({ status: selectedStatus })
        }
        data-testid={
          testId ? `${testId}-status-select` : 'task-filters-status-select'
        }
      />
    </BasicFilters>
  )
}

const MultiSelectNarrow = styled(MultiSelectWide)`
  min-width: 170px;
` as typeof MultiSelectWide

const StatusBadgeStyled = styled(StatusBadge)`
  padding: 4px 8px;
`

export default TaskFilters
